// ─── AI Demand Forecasting ────────────────────────────────────────────────────

export interface MockSalesTrend {
    itemId: string;
    itemName: string;
    month: number;
    year: number;
    actualSales: number;
    forecastSales: number;
    accuracy: number;
}

export interface MockForecast {
    id: string;
    itemId: string;
    itemName: string;
    forecastMonth: number;
    forecastYear: number;
    predictedQty: number;
    confidence: number;
    trend: 'INCREASING' | 'DECREASING' | 'STABLE' | 'SEASONAL';
    seasonalFactor: number | null;
    suggestedProductionQty: number;
    suggestedPurchaseQty: number;
    basedOnMonths: number;
    generatedAt: string;
}

export let mockSalesTrends: MockSalesTrend[] = [
    { itemId: 'itm-018', itemName: 'Industrial Pump X', month: 4, year: 2026, actualSales: 8, forecastSales: 7, accuracy: 87.5 },
    { itemId: 'itm-018', itemName: 'Industrial Pump X', month: 5, year: 2026, actualSales: 6, forecastSales: 7, accuracy: 85.7 },
    { itemId: 'itm-018', itemName: 'Industrial Pump X', month: 6, year: 2026, actualSales: 9, forecastSales: 8, accuracy: 88.9 },
    { itemId: 'itm-018', itemName: 'Industrial Pump X', month: 7, year: 2026, actualSales: 11, forecastSales: 9, accuracy: 81.8 },
    { itemId: 'itm-018', itemName: 'Industrial Pump X', month: 8, year: 2026, actualSales: 10, forecastSales: 11, accuracy: 90.9 },
    { itemId: 'itm-018', itemName: 'Industrial Pump X', month: 9, year: 2026, actualSales: 0, forecastSales: 12, accuracy: 0 },
    { itemId: 'itm-017', itemName: 'Gear Assembly A', month: 4, year: 2026, actualSales: 25, forecastSales: 22, accuracy: 88 },
    { itemId: 'itm-017', itemName: 'Gear Assembly A', month: 5, year: 2026, actualSales: 28, forecastSales: 26, accuracy: 92.9 },
    { itemId: 'itm-017', itemName: 'Gear Assembly A', month: 6, year: 2026, actualSales: 22, forecastSales: 27, accuracy: 81.5 },
    { itemId: 'itm-017', itemName: 'Gear Assembly A', month: 7, year: 2026, actualSales: 30, forecastSales: 24, accuracy: 80 },
    { itemId: 'itm-017', itemName: 'Gear Assembly A', month: 8, year: 2026, actualSales: 27, forecastSales: 29, accuracy: 93.1 },
    { itemId: 'itm-017', itemName: 'Gear Assembly A', month: 9, year: 2026, actualSales: 0, forecastSales: 31, accuracy: 0 },
];

export let mockForecasts: MockForecast[] = [
    {
        id: 'fc-001', itemId: 'itm-018', itemName: 'Industrial Pump X',
        forecastMonth: 10, forecastYear: 2026,
        predictedQty: 13, confidence: 82,
        trend: 'INCREASING', seasonalFactor: 1.08,
        suggestedProductionQty: 15, suggestedPurchaseQty: 0,
        basedOnMonths: 6, generatedAt: '2026-09-28T08:00:00Z',
    },
    {
        id: 'fc-002', itemId: 'itm-017', itemName: 'Gear Assembly A',
        forecastMonth: 10, forecastYear: 2026,
        predictedQty: 33, confidence: 78,
        trend: 'INCREASING', seasonalFactor: 1.10,
        suggestedProductionQty: 35, suggestedPurchaseQty: 0,
        basedOnMonths: 6, generatedAt: '2026-09-28T08:00:00Z',
    },
    {
        id: 'fc-003', itemId: 'itm-016', itemName: 'Steel Rod 10mm',
        forecastMonth: 10, forecastYear: 2026,
        predictedQty: 850, confidence: 91,
        trend: 'STABLE', seasonalFactor: 1.0,
        suggestedProductionQty: 0, suggestedPurchaseQty: 1000,
        basedOnMonths: 6, generatedAt: '2026-09-28T08:00:00Z',
    },
];

export function generateForecastId(): string {
    return `fc-${String(mockForecasts.length + 1).padStart(3, '0')}`;
}